<template lang="pug">
div
	.form-group
		label
			b Agenda
		input-query(
			placeholder="Busca una evento de agenda",
			@selected="seleccionada($event)"
			input-class="form-control"
			:realtime="true"
			url="redaccion/php/api/buscar-agenda.php"
			v-if="!readonly")
	hr(v-if="!readonly")
	button.btn.btn-sm.btn-warning.m-1(
		v-for="agenda in texto.Agenda"
		:key="agenda.AgendaID"
		@click="quitar(agenda.AgendaID)"
	) {{agenda.Titulo}}
</template>

<script>
import axios from 'axios'
export default {
	props: ['texto', 'readonly'],
	methods: {
		seleccionada (ev) {
			if (this.readonly) {
				return
			}
			const form = {
				AgendaID: ev.datos.AgendaID,
				NoticiaID: this.texto.NoticiaID
			}
			axios.post('redaccion/php/api/add-agenda.php', form)
				.then(res => {
					this.texto.Agenda = res.data
				})
				.catch(this.$responseError)
		},
		quitar (AgendaID) {
			if (this.readonly) {
				return
			}
			const form = {
				NoticiaID: this.texto.NoticiaID,
				AgendaID: AgendaID
			}
			axios.post('redaccion/php/api/del-agenda.php', form)
				.then(res => {
					this.texto.Agenda = res.data
				})
				.catch(this.$responseError)
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/editor/agenda.vue